/**
 * Тур по странице технічного обслуговування.
 * Знакомит пользователя с управлением задачами ТО.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'maintenance-page',
  name: 'help.tours.maintenance.name',
  description: 'help.tours.maintenance.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие - тулбар
    {
      element: '.tasks-toolbar',
      titleKey: 'help.tours.maintenance.welcome.title',
      descriptionKey: 'help.tours.maintenance.welcome.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 2: Табы (задачи, історія, імпорт)
    {
      element: '.panel-tabs',
      titleKey: 'help.tours.maintenance.tabs.title',
      descriptionKey: 'help.tours.maintenance.tabs.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 3: Панель инструментов
    {
      element: '.tasks-toolbar__right',
      titleKey: 'help.tours.maintenance.toolbar.title',
      descriptionKey: 'help.tours.maintenance.toolbar.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 4: Список задач
    {
      element: '.tasks-list, .tasks-empty',
      titleKey: 'help.tours.maintenance.tasksList.title',
      descriptionKey: 'help.tours.maintenance.tasksList.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 5: Панель выбора устройства
    {
      element: '.side-panel--left',
      titleKey: 'help.tours.maintenance.devicePanel.title',
      descriptionKey: 'help.tours.maintenance.devicePanel.description',
      side: 'left',
      align: 'start',
    },
  ],
}
